<div class="modal-header text-center">
    <h4 class="modal-title display-inline-block ">{{userName}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>    
</div>

<div class="modal-body">    
    <!-- <div *ngFor="let badge of badges">
        {{badge.getCategory()}} => {{badge.getScopeDescription()}}
    </div> -->

    @if(!processing()) {
    <table class="table">
        <thead>
            <tr>
                <th class="text-center">
                    <div>
                        <app-superelf-badge-icon size="1x" [badgeCategory]="Goal"></app-superelf-badge-icon>
                    </div>                    
                    <div class="fw-lighter">{{nameService.getBadgeCategoryName(Goal)}}</div>                    
                </th>              
                <th class="text-center">
                    <div>
                        <app-superelf-badge-icon size="1x" [badgeCategory]="Assist"></app-superelf-badge-icon>
                    </div>
                    <div class="fw-lighter">{{nameService.getBadgeCategoryName(Assist)}}</div>
                </th>
                <th class="text-center">
                    <div>
                        <app-superelf-badge-icon size="1x" [badgeCategory]="Result"></app-superelf-badge-icon>
                    </div>
                    <div class="fw-lighter">{{nameService.getBadgeCategoryName(Result)}}</div>
                </th>
                <th class="text-center">
                    <div>
                        <app-superelf-badge-icon size="1x" [badgeCategory]="Sheet"></app-superelf-badge-icon>
                    </div>
                    <div class="fw-lighter">{{nameService.getBadgeCategoryName(Sheet)}}</div>
                </th>
                <th class="text-center">
                    <div>
                        <app-superelf-badge-icon size="1x" [badgeCategory]="Card"></app-superelf-badge-icon>
                    </div>
                    <div class="fw-lighter">{{nameService.getBadgeCategoryName(Card)}}</div>
                </th>
            </tr>
        </thead>
        <tbody>
            @for(badgeLineNr of getMaxLineNumbers(); track badgeLineNr){
            <tr>
                <td class="text-center">
                    @if(getBadgeSeasonShortName(Goal, badgeLineNr)) {
                        <div class="badge bg-secondary mb-1 ms-1 px-1">
                        {{getBadgeSeasonShortName(Goal, badgeLineNr)}}</div>
                    }
                </td>
                <td class="text-center">
                    @if(getBadgeSeasonShortName(Assist, badgeLineNr)) {
                        <div class="badge bg-secondary mb-1 ms-1 px-1">
                            {{getBadgeSeasonShortName(Assist, badgeLineNr)}}</div>
                    }
                </td>
                <td class="text-center">
                    @if(getBadgeSeasonShortName(Result, badgeLineNr)) {
                        <div class="badge bg-secondary mb-1 ms-1 px-1">
                            {{getBadgeSeasonShortName(Result, badgeLineNr)}}</div>
                    }
                </td>
                <td class="text-center">
                    @if(getBadgeSeasonShortName(Sheet, badgeLineNr)) {
                        <div class="badge bg-secondary mb-1 ms-1 px-1">
                            {{getBadgeSeasonShortName(Sheet, badgeLineNr)}}</div>
                    }
                </td>
                <td class="text-center">
                    @if(getBadgeSeasonShortName(Card, badgeLineNr)) {
                        <div class="badge bg-secondary mb-1 ms-1 px-1">
                            {{getBadgeSeasonShortName(Card, badgeLineNr)}}</div>
                    }
                </td>
            </tr>
            }
        </tbody>
    </table>
    }

    <!-- <div *ngIf="currentTrophy" class="text-center">    
        <div><h4>{{getTrophyTitle(currentTrophy)}}</h4></div>
        <div>
            <app-superelf-trophy-icon size="10x" [leagueName]="nameService.convertToLeagueName(currentTrophy.getCompetition())"></app-superelf-trophy-icon>
        </div>
        <div><h2 class="fw-bold">{{currentTrophy.poolUser.user.name}}</h2></div>
    </div>
    <div *ngIf="currentBadge" class="text-center">    
        <div><h4>{{currentBadge.getScopeDescription()}}</h4></div>
        <div><h4>{{nameService.getBadgeCategoryName(currentBadge.getCategory())}}-badge</h4></div>
        <div>
            <app-superelf-badge-icon size="5x" [badgeCategory]="currentBadge.getCategory()"></app-superelf-badge-icon>
        </div>
        <div><h2 class="fw-bold">{{currentBadge.poolUser.user.name}}</h2></div>
    </div> -->
    
</div>
<div class="modal-footer d-flex justify-content-around border-top-0">
    <!-- <button type="button" class="btn btn-secondary" [attr.disabled]="previousAchievements.length === 0 ? true : null" (click)="previous()">vorige</button>
    <button *ngIf="nextAchievements.length > 0" type="button" class="btn btn-secondary" (click)="next()">volgende</button>
    <button *ngIf="nextAchievements.length === 0" type="button" class="btn btn-secondary" (click)="modal.dismiss('close')">sluiten</button> -->
</div>

